<template>
    <div class="bannerModule" v-show="adData || adList.length">
        <a @click="clickAd(adData)" target="_blank" v-if="adData">
            <img class="fullSpace block cover roundBorder8" :src="adData.img" alt="" style="height: auto"/>
        </a>
        <div v-if="adList && adList.length">
            <a @click="clickAd(adList[0])" target="_blank" :key="adList[0].image">
                <img class="fullSpace block cover roundBorder8" :src="adList[0].img" alt="" style="height: auto"/>
            </a>
        </div>
    </div>
</template>

<script>

import adModulePart from '@comp/ad/adModulePart';

// config
import appConfig    from '../../appConfig';

//
import appHelper    from "@util/appHelper";

let config = {

};

export default {
    name: "oneImageAdModule",
    extends : adModulePart,
    props : {
        itemCount : {
            type : Number,
            default : 1
        },
    },
    methods : {
        onLoadData : function(data) {
            this.$emit('loadData', data);
        }
    },
    mounted() {

        if (appConfig.mode == 'demo')
        {
            this.adData = {
                coverImg : appHelper.getRandomCoverImage(),
                link : 'https://yj.shixun365.com/'
            };
        }
    }
}
</script>

<style scoped>

</style>
